export const reactCarouselBreakPoints = (isMobile, override) => {
    if (!override) {
        return {
            '1600': 4,
            '1200': 4,
            '992': 4,
            '768': 4,
            '480': 3,
            '0': isMobile ? 2 : 4,
        };
    }
    return override;
};
